export default __webpack_public_path__ + "static/media/04AW2NOV65.22ec12b5.jpg";